export default function Timer() {
  return <div id="timer"></div>;
}
